import React from 'react';
import { SvgIcon } from '@material-ui/core';

const AddTankIcon = (props) => {
  return(
    <SvgIcon {...props}>
      <path d="M 4.63,2.11
           C 3.55,2.54 3.91,4.27 5.07,4.27
             5.07,4.27 5.52,4.27 5.52,4.27
             5.52,4.27 5.52,7.06 5.52,7.06
             5.52,7.06 5.52,9.84 5.52,9.84
             5.52,9.84 5.22,9.84 5.22,9.84
             4.47,9.84 4.00,10.32 4.00,11.09
             4.00,11.73 4.39,12.11 5.05,12.11
             5.05,12.11 5.52,12.11 5.52,12.11
             5.52,12.11 5.52,14.88 5.52,14.88
             5.52,14.88 5.52,17.65 5.52,17.65
             5.52,17.65 5.05,17.73 5.05,17.73
             3.83,17.92 3.55,19.46 4.65,19.91
             5.24,20.15 17.76,20.15 18.35,19.91
             19.44,19.47 19.16,17.91 17.95,17.73
             17.95,17.73 17.48,17.65 17.48,17.65
             17.48,17.65 17.48,14.88 17.48,14.88
             17.48,14.88 17.48,12.11 17.48,12.11
             17.48,12.11 17.93,12.11 17.93,12.11
             19.09,12.11 19.45,10.53 18.42,10.01
             18.23,9.92 17.94,9.84 17.78,9.84
             17.78,9.84 17.48,9.84 17.48,9.84
             17.48,9.84 17.48,7.06 17.48,7.06
             17.48,7.06 17.48,4.27 17.48,4.27
             17.48,4.27 17.90,4.27 17.90,4.27
             18.85,4.27 19.36,3.10 18.72,2.38
             18.72,2.38 18.43,2.06 18.43,2.06
             18.43,2.06 11.66,2.03 11.66,2.03
             7.93,2.02 4.77,2.06 4.63,2.11M 12.09,8.82
           C 12.09,8.82 12.09,10.41 12.09,10.41
             12.09,10.41 13.67,10.41 13.67,10.41
             13.67,10.41 15.25,10.41 15.25,10.41
             15.25,10.41 15.25,11.03 15.25,11.03
             15.25,11.03 15.25,11.66 15.25,11.66
             15.25,11.66 13.67,11.66 13.67,11.66
             13.67,11.66 12.09,11.66 12.09,11.66
             12.09,11.66 12.09,13.25 12.09,13.25
             12.09,13.25 12.09,14.84 12.09,14.84
             12.09,14.84 11.38,14.84 11.38,14.84
             11.38,14.84 10.68,14.84 10.68,14.84
             10.68,14.84 10.68,13.25 10.68,13.25
             10.68,13.25 10.68,11.66 10.68,11.66
             10.68,11.66 9.10,11.66 9.10,11.66
             9.10,11.66 7.52,11.66 7.52,11.66
             7.52,11.66 7.52,11.03 7.52,11.03
             7.52,11.03 7.52,10.41 7.52,10.41
             7.52,10.41 9.10,10.41 9.10,10.41
             9.10,10.41 10.68,10.41 10.68,10.41
             10.68,10.41 10.68,8.82 10.68,8.82
             10.68,8.82 10.68,7.23 10.68,7.23
             10.68,7.23 11.38,7.23 11.38,7.23
             11.38,7.23 12.09,7.23 12.09,7.23
             12.09,7.23 12.09,8.82 12.09,8.82" />
    </SvgIcon>
  )
}

export default AddTankIcon;
